export const Alert = {
  defaultProps: {
    variant: 'solid',
  },
};
